import { useState } from "react";
import { SVGICONS } from "config";
import { useSelector } from "react-redux";
import { t } from "i18next";
import ChangePickupStoreModal from "./ChangePickupStoreModal";
import { CustomButton } from "components/Button";
import { TranslationText } from "components/TextTranslationContainer";

const PickupFrom = () => {
  const { selectedStore } = useSelector((state) => state?.store);
  const [actionModal, setActionModal] =useState(false);

  return (
    <>
      <TranslationText
        text="Pickup from"
        className="text-16x font-semibold text-shadow-forge-900"
        as="h4"
      />
      <div
        className="flex items-start gap-3 justify-between rounded-16x px-4 py-3 text-shadow-forge-800"
        style={{ border: "1.5px solid #E5E7EB" }}
      >
        <SVGICONS.LocationIcon
          className="flex-shrink-0 "
          width={20}
          height={20}
        />
        <div className="flex-1 flex flex-col gap-1">
          <TranslationText text={selectedStore?.baseLanguage?.name} className="text-14x w-full break-words block text-brand-base-primary font-bold" as="h4" />
          <TranslationText text={selectedStore?.manualAddress ?? t("Select Location")} className="text-14x w-full break-words block" as="h6" />
        </div>
        <CustomButton
          id="delivery-address-change"
          onClick={() => setActionModal(true)}
          className="w-fit"
          outline
          title={t("Change")}
          style={{
            padding: "0px 5px",
            borderRadius: "8px",
          }}
        />
      </div>
      <ChangePickupStoreModal {...{ actionModal, setActionModal }} />
    </>
  );
};

export default PickupFrom;
